<script>
  import {AppStore} from '../stores/AppStore'

  let tempAudioLengths = {}
  
  let sources = []
  let previousPodcastID = null;
  let previousDurationIndex = null;
  $: {
    if ($AppStore.podcasts) {
      //Get the current ID/duration from the store
      let podcastID = $AppStore.state.activePodcastID
      let durationIndex = $AppStore.state.durationIndex

      //If the same podcast and duration are loaded, ignore
      if (previousPodcastID === podcastID && previousDurationIndex === durationIndex) {
        
      } else {
        //Store the ids
        previousPodcastID = podcastID
        previousDurationIndex = durationIndex
      
        //TODO : PodcastID and index are the same but they might not be going forwards
        let podcastChunks = $AppStore.podcasts[podcastID].playlists[durationIndex].playlist

        //If we're playing the full playlist, the .playlist param will be blank. Populate podcastChunks with ALL possible chunks
        if (podcastChunks.length === 0) {
          podcastChunks = Array.from({length:$AppStore.podcasts[podcastID].chunkCount}, (_,k) => k+1 )
        }

        //Setup the sources from the available podcast chunks
        sources = podcastChunks.map( chunk => `./audio/${podcastID}/${chunk}.mp3`)

        // //Set the sources on the audio element
        // if (sources.length) {
        //   audioEl.src = sources[0]
        //   console.log("Source set to :", sources[0])
        // }

        //Calculate the total duration
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        let totalDuration = podcastChunks.map( chunk => $AppStore.podcasts[podcastID].durations[`${chunk}`] ).reduce(reducer)
        console.debug("Total Duration", totalDuration)

        //Reset the currently playing chunk index
        AppStore.setActiveChunkIndex(0)

        //Preload all the audio elements 
        // tempAudioLengths = {}
        // sources.forEach(src => {
        //   const audio = new Audio();
        //   audio.addEventListener('canplaythrough', chunkLoaded, false);
        //   audio.src = src;
        // })

        // //Reload the audio controls to match the new file
        // audioEl.load()
      } 
    }
  }

  // const chunkLoaded = (chunk) => {
  //   const src = chunk.path[0].src
  //   const split = src.split("/")
  //   const fileIndex = split[split.length - 1].replace(".mp3", "")
  //   // console.log("Loaded chunk", fileIndex)
  //   tempAudioLengths[fileIndex] = chunk.path[0].duration
  //   console.log(tempAudioLengths)
  // }

  const currentFileEnded = () => {
    //If there are more files to play, load the new src
    if ($AppStore.state.activeChunkIndex < (sources.length - 1)) {

      const nextChunkIndex = $AppStore.state.activeChunkIndex + 1

      //Start playing on the next audio element
      document.getElementById(nextChunkIndex).play()

      //Up the currently playing chunk index to unhide the controls
      AppStore.setActiveChunkIndex(nextChunkIndex)

      console.log("Source set to :", sources[nextChunkIndex])
    }
  }

  // $:console.log(sources)
  // $:console.log($AppStore.state.activeChunkIndex)

</script>

<style>

  /* https://stackoverflow.com/a/33948255 */
  /* audio::-webkit-media-controls-current-time-display {
    opacity: 0;
  }

  audio::-webkit-media-controls-time-remaining-display {
    opacity: 0;
  }

  #times {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    font-size: 0.8em;
    pointer-events: none;
  }

  #completed {
    padding-left: 44px;
  }

  #total {
    padding-left: 2px;
  } */

</style>

<div class="">
  <div class="relative">
    {#each sources as source, sourceIndex}
      <audio
        controls
        preload
        src={source}
        id={sourceIndex}
        class="border-none outline-none"
        class:hidden={sourceIndex !== $AppStore.state.activeChunkIndex}
        on:ended={currentFileEnded}
      >
      </audio>
    {/each}
    <!-- <div id="times">
      <span id="completed">00:00</span>
      <span id="total">/ 02:47</span>
    </div> -->
  </div>
</div>